import CheckEnclosed from '@/public/cmsAssets/assets/img/progress-stepper/CheckEnclosed';
import ChevronRightFilled from '@/public/cmsAssets/assets/img/progress-stepper/CheckFilled';
import CheckFilled from '@/public/cmsAssets/assets/img/progress-stepper/ChevronRightFilled';

import useStyles from './ProgressStepper.styles';

export interface ProgressStepperProps {
  steps: string[];
  lastCompletedStep: number;
}

export function ProgressStepper({
  steps,
  lastCompletedStep,
}: ProgressStepperProps) {
  const { classes } = useStyles();
  return (
    <div>
      {steps.map((step, index) => (
        <div className={classes.step} key={step}>
          <div className={classes.progressBar}>
            {index + 1 < lastCompletedStep ? (
              <CheckFilled />
            ) : index + 1 === lastCompletedStep ? (
              <ChevronRightFilled />
            ) : (
              <CheckEnclosed />
            )}
            {index != steps.length - 1 && (
              <div className={classes.connectorLine} />
            )}
          </div>
          <p className={classes.stepText}>{step}</p>
        </div>
      ))}
    </div>
  );
}
